import React from "react";

/**
 * PrepTimeInput
 * Two number inputs (hrs / mins) styled as a single unified input,
 * matching the existing Input.Label design.
 *
 * Emits { target: { name, value } } where value is "H:MM" or "".
 */
export default function PrepTimeInput({
  title,
  value = "",
  onChange,
  name = "food_preparation_time",
}) {
  const [h, m] = value ? value.split(":") : ["", ""];

  const emit = (hours, minutes) => {
    const empty = hours === "" && minutes === "";
    onChange({
      preventDefault: () => {},
      target: {
        name,
        value: empty
          ? ""
          : `${String(hours || 0).padStart(2, "0")}:${String(minutes || 0).padStart(2, "0")}`,
      },
    });
  };

  const handleHours = (e) => {
    const raw = e.target.value;
    const val = raw === "" ? "" : Math.max(0, Math.min(23, Number(raw)));
    emit(val, m);
  };

  const handleMinutes = (e) => {
    const raw = e.target.value;
    const val = raw === "" ? "" : Math.max(0, Math.min(59, Number(raw)));
    emit(h, val);
  };

  return (
    <div>
      <label className="block text-sm font-medium text-[#151515] dark:text-white">
        {title ?? "Preparation Time"}
      </label>
      <div className="mt-2 mb-4 flex items-center h-[40px] border border-gray-300 bg-[#FFFFFF] dark:bg-transparent sm:text-sm">
        <input
          type="number"
          min={0}
          max={23}
          placeholder="0"
          value={h}
          onChange={handleHours}
          aria-label="Hours"
          className="w-full h-full text-center bg-transparent focus:outline-none focus:ring-0 px-2 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
        />
        <span className="text-[#717485] text-xs px-1 shrink-0">hrs</span>
        <div className="w-px h-5 bg-gray-300 shrink-0" />
        <input
          type="number"
          min={0}
          max={59}
          placeholder="0"
          value={m}
          onChange={handleMinutes}
          aria-label="Minutes"
          className="w-full h-full text-center bg-transparent focus:outline-none focus:ring-0 px-2 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
        />
        <span className="text-[#717485] text-xs px-2 shrink-0">mins</span>
      </div>
    </div>
  );
}
